/* bmcE-sales.js: course sales pages (template product.bmc-sales), group E whole-store Josh pass, 2026-09-28.
   Loaded only by snippets/bmcE-sales.liquid (never on a bmc-landing* page).
   1) Sticky buy bar: hides while the reader scrolls down, comes back on scroll up (P3).
   2) Buy buttons show "Opening secure checkout" while checkout loads (P35).
   3) Hero image: tap to zoom, plus a swipeable gallery with arrows and thumbnails when the course has more than one image (P17, P19, P21, P22).
   The "More courses you might like" row (P66) is rendered server-side in snippets/bmcE-sales.liquid. */
(function () {
  'use strict';
  if (window.bmcE) return;
  window.bmcE = { v: '2026-09-28' };

  /* 1) Buy bar */
  var bar = document.getElementById('bmcE-bar');
  if (bar) {
    var setH = function () { document.documentElement.style.setProperty('--bmcE-bar-h', bar.offsetHeight + 'px'); };
    setH();
    window.addEventListener('resize', setH);
    /* f9l (W3E, G10): the bar starts hidden (class set in the markup) and shows only once the hero Buy Now has scrolled
       up out of view, so it never covers that button. Past it, the bar hides while the reader scrolls down and comes
       back on scroll up (P3). No hero buy link on the page: the bar behaves as before. */
    var heroBuy = document.querySelector('.bmc .bmc-course-hero a[href^="/cart/"]');
    var pastHero = function () {
      if (!heroBuy) return true;
      var r = heroBuy.getBoundingClientRect();
      return (r.width === 0 && r.height === 0) || r.bottom < 0;
    };
    var last = window.pageYOffset || 0, ticking = false, goingUp = true;
    var apply = function () { bar.classList.toggle('bmcE-bar--hide', !(pastHero() && goingUp)); };
    var onScroll = function () {
      var y = window.pageYOffset || 0, d = y - last;
      if (Math.abs(d) > 6) {
        goingUp = !(d > 0 && y > 200);
        last = y;
      }
      apply();
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    apply();
    bar.addEventListener('focusin', function () { bar.classList.remove('bmcE-bar--hide'); });
    bar.querySelectorAll('.bmcE-bar__nav a').forEach(function (a) {
      a.addEventListener('click', function () { window.setTimeout(function () { goingUp = true; apply(); }, 700); });
    });
  }

  /* In-page jumps (bar sections, hero checks) scroll without adding history entries, so Back still leaves the page (P7). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#bmcE-"]');
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
    if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
    try { t.focus({ preventScroll: true }); } catch (err) {}
  });

  /* 2) Busy state on every buy path (links to /cart/<variant>:1 and the bar form). Navigation is never blocked. */
  var BUSY = 'Opening checkout';
  var busy = function (el) {
    if (!el || el.classList.contains('bmcE-busy')) return;
    var lbl = el.querySelector('.bmcE-bar__lbl') || el;
    el.setAttribute('data-bmce-label', lbl.textContent);
    if (lbl === el) {
      /* keep child icons, replace only the text nodes */
      Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = BUSY; });
      if (!el.textContent.trim()) el.appendChild(document.createTextNode(BUSY));
    } else {
      lbl.textContent = BUSY;
    }
    el.classList.add('bmcE-busy');
    el.setAttribute('aria-busy', 'true');
  };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.bmc a[href^="/cart/"]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) busy(a);
  });
  document.querySelectorAll('.bmcE-bar__form').forEach(function (f) {
    f.addEventListener('submit', function () { busy(f.querySelector('button')); });
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.bmcE-busy').forEach(function (el) {
      var old = el.getAttribute('data-bmce-label') || 'Buy Now';
      var lbl = el.querySelector('.bmcE-bar__lbl');
      if (lbl) lbl.textContent = old;
      else Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = old; });
      el.classList.remove('bmcE-busy');
      el.removeAttribute('aria-busy');
    });
  });

  /* 3) Hero image zoom + gallery */
  var ICON_ZOOM = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M10 2a8 8 0 0 1 6.3 12.9l5.4 5.4-1.4 1.4-5.4-5.4A8 8 0 1 1 10 2Zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm1 2v3h3v2h-3v3H9v-3H6V9h3V6h2Z"/></svg>';
  var media = document.querySelector('.bmc .bmc-course-hero__media');
  var heroImg = media && media.querySelector('img');
  var data = { media: [] };
  try { data = JSON.parse((document.getElementById('bmcE-gal-data') || {}).textContent || '{}'); } catch (err) { data = { media: [] }; }
  if (media && heroImg) {
    var slides = [{ src: heroImg.currentSrc || heroImg.src, alt: heroImg.alt || data.title || '' }].concat(data.media || []);
    /* f75 (W2E): the course video is slide 2, a poster only; the player loads after a tap (bmcE.playVideo). */
    var vid = data.video && data.video.embed ? data.video : null;
    if (vid) slides.splice(1, 0, { video: vid, src: vid.poster, thumb: vid.thumb || vid.poster, alt: vid.label });
    var lb = null, lbIdx = 0;
    var openLb = function (i) {
      lbIdx = i;
      if (!lb) {
        lb = document.createElement('dialog');
        lb.className = 'bmcE-lb';
        lb.setAttribute('aria-label', 'Image viewer');
        lb.innerHTML = '<p class="bmcE-lb__cap"></p><button type="button" class="bmcE-lb__close" aria-label="Close image viewer">&times;</button>' +
          '<div class="bmcE-lb__stage"><img alt=""></div>' +
          (slides.length > 1 ? '<button type="button" class="bmcE-gal__nav bmcE-gal__nav--prev" aria-label="Previous image">&#8249;</button><button type="button" class="bmcE-gal__nav bmcE-gal__nav--next" aria-label="Next image">&#8250;</button>' : '');
        document.body.appendChild(lb);
        lb.querySelector('.bmcE-lb__close').addEventListener('click', function () { lb.close(); });
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('bmcE-lb__stage')) lb.close(); });
        lb.querySelector('.bmcE-lb__stage img').addEventListener('click', function (e) { e.stopPropagation(); lb.classList.toggle('is-zoomed'); });
        var p = lb.querySelector('.bmcE-gal__nav--prev'), n = lb.querySelector('.bmcE-gal__nav--next');
        if (p) p.addEventListener('click', function () { show(lbIdx - 1, -1); });
        if (n) n.addEventListener('click', function () { show(lbIdx + 1, 1); });
        lb.addEventListener('close', function () { lb.classList.remove('is-zoomed'); });
      }
      var show = function (k, dir) {
        lbIdx = (k + slides.length) % slides.length;
        if (slides[lbIdx].video) lbIdx = (lbIdx + (dir || 1) + slides.length) % slides.length;
        var s = slides[lbIdx], im = lb.querySelector('.bmcE-lb__stage img');
        im.src = s.src; im.alt = s.alt || '';
        lb.classList.remove('is-zoomed');
        lb.querySelector('.bmcE-lb__cap').textContent = (slides.length > 1 ? (lbIdx + 1) + ' of ' + slides.length + ': ' : '') + (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches ? 'Click' : 'Tap') + ' the image to zoom in';
      };
      openLb.show = show;
      show(i);
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
    };
    var hint = document.createElement('span');
    hint.className = 'bmcE-hint';
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    hint.innerHTML = ICON_ZOOM + '<span>' + (fine ? 'Click to zoom' : 'Tap to zoom') + '</span>';
    if (slides.length === 1) {
      var z = document.createElement('button');
      z.type = 'button'; z.className = 'bmcE-zoom';
      z.setAttribute('aria-label', 'Zoom image: ' + (heroImg.alt || data.title || 'course image'));
      heroImg.parentNode.insertBefore(z, heroImg);
      z.appendChild(heroImg);
      z.addEventListener('click', function () { openLb(0); });
      media.appendChild(hint);
    } else {
      var wrap = document.createElement('div');
      wrap.className = 'bmcE-media-wrap';
      media.parentNode.insertBefore(wrap, media);
      wrap.appendChild(media);
      var gal = document.createElement('div');
      gal.className = 'bmcE-gal';
      gal.setAttribute('role', 'region');
      gal.setAttribute('aria-label', 'Course images, swipe or use the arrows');
      var track = document.createElement('div');
      track.className = 'bmcE-gal__track';
      track.tabIndex = 0;
      var dots = document.createElement('div');
      dots.className = 'bmcE-gal__dots';
      var thumbs = document.createElement('div');
      thumbs.className = 'bmcE-thumbs';
      slides.forEach(function (s, i) {
        var fig = document.createElement('figure');
        fig.className = 'bmcE-gal__slide';
        var b = document.createElement('button');
        b.type = 'button';
        if (s.video) {
          /* f75 (W2E): video slide = poster + play button; the player loads only after the tap */
          b.className = 'bmcE-vslide' + (s.video.aspect === '9:16' ? ' bmcE-vslide--tall' : '');
          b.setAttribute('aria-label', 'Play video: ' + s.video.label + ' (' + s.video.dur + ')');
          b.innerHTML = '<img alt="" loading="lazy" decoding="async"><span class="bmcE-vslide__play" aria-hidden="true"></span><span class="bmcE-vslide__cap" aria-hidden="true"></span>';
          var vim = b.querySelector('img');
          vim.addEventListener('error', function () { if (/maxresdefault/.test(vim.src)) vim.src = vim.src.replace('maxresdefault', 'hqdefault'); });
          vim.src = s.src;
          b.querySelector('.bmcE-vslide__cap').textContent = 'Play: ' + s.video.label + ' (' + s.video.dur + ')';
          b.addEventListener('click', function () { window.bmcE.playVideo(s.video, b); });
          fig.className += ' bmcE-gal__slide--vid';
          fig.appendChild(b);
        } else {
        b.className = 'bmcE-zoom';
        b.setAttribute('aria-label', 'Zoom image ' + (i + 1) + ' of ' + slides.length);
        var im = i === 0 ? heroImg : document.createElement('img');
        if (i > 0) { im.src = s.src; im.alt = s.alt || ''; im.loading = 'lazy'; im.decoding = 'async'; }
        b.appendChild(im);
        b.addEventListener('click', function () { openLb(i); });
        fig.appendChild(b);
        }
        track.appendChild(fig);
        dots.appendChild(document.createElement('i'));
        var t = document.createElement('button');
        t.type = 'button';
        t.setAttribute('aria-label', s.video ? 'Show the video: ' + s.video.label : 'Show image ' + (i + 1) + ' of ' + slides.length);
        t.innerHTML = '<img alt="" loading="lazy">';
        t.querySelector('img').src = s.thumb || s.src;
        if (s.video) t.className = 'bmcE-thumbs__vid';
        t.addEventListener('click', function () { go(i); });
        thumbs.appendChild(t);
      });
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'bmcE-gal__nav bmcE-gal__nav--prev'; prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = '&#8249;';
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'bmcE-gal__nav bmcE-gal__nav--next'; next.setAttribute('aria-label', 'Next image'); next.innerHTML = '&#8250;';
      gal.appendChild(track); gal.appendChild(prev); gal.appendChild(next); gal.appendChild(dots);
      media.innerHTML = '';
      media.appendChild(gal);
      media.appendChild(hint);
      wrap.appendChild(thumbs);
      var cur = 0;
      var mark = function (i) {
        cur = i;
        hint.style.visibility = slides[i] && slides[i].video ? 'hidden' : '';
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
        Array.prototype.forEach.call(thumbs.children, function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      var go = function (i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        mark(i);
      };
      prev.addEventListener('click', function () { go(cur - 1); });
      next.addEventListener('click', function () { go(cur + 1); });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(cur - 1); if (e.key === 'ArrowRight') go(cur + 1); });
      var sT = null;
      track.addEventListener('scroll', function () {
        window.clearTimeout(sT);
        sT = window.setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 80);
      }, { passive: true });
      mark(0);
      /* f75 (W2E): "Watch" block under the thumbnails: jumps to the video slide and opens the player */
      if (vid) {
        var vi = 1;
        var wb = document.createElement('div');
        wb.className = 'bmcE-watch';
        wb.innerHTML = '<button type="button" class="bmcE-watch__btn"><span class="bmcE-watch__ico" aria-hidden="true"></span><span class="bmcE-watch__txt"><b></b><small></small></span></button><p class="bmcE-watch__note"></p>';
        var wbtn = wb.querySelector('button');
        wb.querySelector('b').textContent = vid.head + ' (' + vid.dur + ')';
        wb.querySelector('small').textContent = vid.label;
        wb.querySelector('.bmcE-watch__note').textContent = vid.note + ' Plays here, no sign up.';
        wbtn.addEventListener('click', function () { go(vi); window.bmcE.playVideo(vid, wbtn); });
        wrap.appendChild(wb);
      }
    }
  }

})();

/* f58 offers (Dan 2026-09-28): the free book ships only to the US, UK and Canada, so its card ([data-bmce-geo]) shows
   only for a visitor from one of those countries (sessionStorage bmc_geo_country, filled from
   /browsing_context_suggestions.json, the same key the landing pages use). Unknown country: stays hidden. */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-bmce-geo]');
  if (!els.length) return;
  var show = function (code) {
    code = String(code || '').toUpperCase();
    var pair = document.getElementById('bmcE-pair');
    var wasHidden = pair ? pair.hidden : false;
    Array.prototype.forEach.call(els, function (el) {
      el.hidden = (el.getAttribute('data-bmce-geo') || '').split(',').indexOf(code) < 0;
    });
    if (pair && wasHidden && !pair.hidden && window.location.hash === '#bmcE-pair') pair.scrollIntoView({ block: 'center' });
  };
  var c = null;
  try { c = sessionStorage.getItem('bmc_geo_country'); } catch (e) {}
  if (c) { show(c); return; }
  fetch('/browsing_context_suggestions.json?source=geolocation_recommendation', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      var code = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      if (code) { try { sessionStorage.setItem('bmc_geo_country', String(code).toUpperCase()); } catch (e) {} show(code); }
    })
    .catch(function () {});
})();

/* f59 offers (Dan 2026-09-28): the closing band's installments line gets its dark backing only once Shopify has
   drawn it (ineligible buyers get no line from Shopify, so no empty box). */
(function () {
  'use strict';
  var boxes = document.querySelectorAll('.bmcE-bterms');
  if (!boxes.length) return;
  var tries = 0;
  var check = function () {
    var left = 0;
    Array.prototype.forEach.call(boxes, function (b) {
      if (b.classList.contains('is-on')) return;
      var pt = b.querySelector('shopify-payment-terms');
      var txt = pt ? ((pt.shadowRoot && pt.shadowRoot.textContent) || pt.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (txt && pt.getBoundingClientRect().height > 0) b.classList.add('is-on'); else left++;
    });
    if (left && ++tries < 25) window.setTimeout(check, 400);
  };
  check();
})();

/* f75 (W2E, swarm wave 2, 2026-09-28): course video player. Click-to-load only: the iframe is created after a tap and
   removed when the dialog closes (so nothing plays in the background). The embed_url comes from bmc_store.video
   exactly as written (youtube-nocookie or Vimeo dnt=1, whole second start/end); autoplay=1 is added only after the tap. */
(function () {
  'use strict';
  if (!window.bmcE || window.bmcE.playVideo) return;
  var dlg = null, back = null;
  var close = function () { if (dlg && dlg.open) dlg.close(); };
  window.bmcE.playVideo = function (v, from) {
    if (!v || !v.embed) return;
    back = from || null;
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'bmcE-vd';
      dlg.innerHTML = '<div class="bmcE-vd__box"><p class="bmcE-vd__cap"></p><button type="button" class="bmcE-vd__close" aria-label="Close the video">&times;</button><div class="bmcE-vd__frame"></div></div>';
      document.body.appendChild(dlg);
      dlg.querySelector('.bmcE-vd__close').addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () {
        var f = dlg.querySelector('.bmcE-vd__frame'); f.innerHTML = '';
        if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (err) {} }
      });
    }
    var tall = v.aspect === '9:16';
    dlg.classList.toggle('bmcE-vd--tall', tall);
    dlg.setAttribute('aria-label', 'Video: ' + v.label);
    dlg.querySelector('.bmcE-vd__cap').textContent = v.label + (v.dur ? ' (' + v.dur + ')' : '');
    var ifr = document.createElement('iframe');
    ifr.src = v.embed + (v.embed.indexOf('?') < 0 ? '?' : '&') + 'autoplay=1';
    ifr.title = v.label;
    ifr.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    ifr.setAttribute('allowfullscreen', '');
    ifr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    var fr = dlg.querySelector('.bmcE-vd__frame'); fr.innerHTML = ''; fr.appendChild(ifr);
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  };
})();

/* f76 (W2E, swarm wave 2, 2026-09-28): student story videos open in the f75 player dialog, only after a tap. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.bmcE-story__play');
    if (!b || !window.bmcE || !window.bmcE.playVideo) return;
    e.preventDefault();
    var id = b.getAttribute('data-bmce-vimeo');
    if (!/^[0-9]+$/.test(id || '')) return;
    window.bmcE.playVideo({ embed: 'https://player.vimeo.com/video/' + id + '?dnt=1&title=0&byline=0&portrait=0', aspect: '16:9',
      label: (b.getAttribute('data-bmce-name') || 'Student') + ', coaching client story', dur: b.getAttribute('data-bmce-dur') || '' }, b);
  });
})();

/* f9l (W3E, swarm wave 3, 2026-09-28)
   1) Phones: the Save for later heart (bmcA.js puts it in the buy bar) moves into the hero buy box, so it never sits
      on the bar's availability text (G10, P3). Wider screens keep it in the bar.
   2) Delivery line (P43): the country Shopify rendered is corrected to the visitor's detected country (the same
      sessionStorage key bmc_geo_country the free book card uses), with its flag. */
(function () {
  'use strict';
  var buy = document.querySelector('#bmcE-bar .bmcE-bar__buy');
  var slot = document.querySelector('.bmc .bmcE-saveslot');
  if (buy && slot && window.matchMedia) {
    var mq = window.matchMedia('(max-width: 640px)');
    var place = function () {
      var h = document.querySelector('#bmcE-bar .bmcA-save--text, .bmcE-saveslot .bmcA-save--text');
      if (!h) return false;
      if (mq.matches) { if (h.parentNode !== slot) slot.appendChild(h); }
      else if (h.parentNode !== buy) buy.insertBefore(h, buy.querySelector('form'));
      slot.classList.toggle('is-on', h.parentNode === slot);
      return true;
    };
    if (!place() && window.MutationObserver) {
      var mo = new MutationObserver(function () { if (place()) mo.disconnect(); });
      mo.observe(buy, { childList: true });
      window.setTimeout(function () { mo.disconnect(); }, 15000);
    }
    var onMq = function () { place(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }

  var ship = document.querySelectorAll('.bmc .bmcE-ship[data-bmce-cc]');
  if (!ship.length) return;
  var flag = function (cc) {
    if (!/^[A-Z]{2}$/.test(cc)) return '';
    return String.fromCodePoint(0x1F1E6 + cc.charCodeAt(0) - 65, 0x1F1E6 + cc.charCodeAt(1) - 65);
  };
  var nameOf = function (cc) {
    try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(cc) || ''; } catch (e) { return ''; }
  };
  var tries = 0;
  var fix = function () {
    var cc = '';
    try { cc = String(sessionStorage.getItem('bmc_geo_country') || '').toUpperCase(); } catch (e) {}
    if (!cc) { if (++tries < 20) window.setTimeout(fix, 500); return; }
    /* f9za (W5SHIP, 2026-10-05): the free book card's time line per country: the US words are in the markup (bmcE-freebook),
       UK and Canada come from its data attributes, anywhere else gets Bookvault's print time only */
    if (cc !== 'US') document.querySelectorAll('.bmc .bmcE-fb__time').forEach(function (p) { p.textContent = (cc === 'GB' && p.getAttribute('data-bmcw5-uk')) || (cc === 'CA' && p.getAttribute('data-bmcw5-ca')) || 'Printed in 3 to 5 business days.'; });
    Array.prototype.forEach.call(ship, function (li) {
      if (li.getAttribute('data-bmce-cc') === cc) return;
      var nm = nameOf(cc), f = flag(cc);
      if (!nm) return;
      var c = li.querySelector('.bmcE-ship__c'), fl = li.querySelector('.bmcE-ship__flag');
      if (c) c.textContent = nm;
      if (fl) fl.textContent = f;
      li.setAttribute('data-bmce-cc', cc);
    });
  };
  fix();
})();

/* f9n (W3E, swarm wave 3, 2026-09-28, P70): long groups fold on phones; module topic lists open on desktop. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (window.matchMedia('(min-width: 900px)').matches) {
    document.querySelectorAll('.bmc details.bmcE-mod').forEach(function (d) { d.open = true; });
  }
  if (!window.matchMedia('(max-width: 640px)').matches) return;
  var n = 0;
  /* fold(group, items, show, noun): keep the first `show` items, the rest open from a 'See all N now' button */
  var fold = function (g, items, show, noun) {
    if (!g || items.length < show + 2) return;
    n++;
    if (!g.id) g.id = 'bmcE-fold-' + n;
    var rest = items.slice(show);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bmcE-fold';
    btn.setAttribute('aria-controls', g.id);
    var set = function (open) {
      rest.forEach(function (c) { c.classList.toggle('bmcE-folded', !open); });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show fewer' : 'See all ' + items.length + (noun ? ' ' + noun : '') + ' now';
    };
    set(false);
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      set(open);
      if (open) { try { rest[0].setAttribute('tabindex', '-1'); rest[0].focus({ preventScroll: true }); } catch (e) {} }
      else { var r = g.getBoundingClientRect(); if (r.top < 0) g.scrollIntoView({ block: 'start' }); }
    });
    g.insertAdjacentElement('afterend', btn);
  };
  var kids = function (g, re) { return Array.prototype.filter.call(g.children, function (c) { return re.test(c.className || c.tagName); }); };
  /* card grids (outcomes, promises, module overviews): 5 or more cards show 3 */
  document.querySelectorAll('.bmc .bmc-grid-3, .bmc .bmc-audience-standard__grid').forEach(function (g) {
    if (g.closest('#bmcE-steps')) return;
    fold(g, kids(g, /\bbmc-card\b|\bbmc-audience-standard__card\b/), 3, '');
  });
  /* numbered problem lists: 5 or more points show 3 */
  document.querySelectorAll('.bmc ol.bmc-list, .bmc ul.bmc-list:not(.bmc-list--modules)').forEach(function (g) { fold(g, kids(g, /^LI$/), 3, ''); });
  /* community posts: 2 of 4; more courses: 2 of 4 */
  document.querySelectorAll('.bmc .bmcE-posts__grid').forEach(function (g) { fold(g, kids(g, /\bbmcE-post\b/), 2, 'posts'); });
  document.querySelectorAll('.bmc .bmcE-cards--more').forEach(function (g) { fold(g, kids(g, /\bbmcE-card\b/), 2, 'courses'); });
})();
